(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-breaks"] && !Shopify.designMode) return;
  try {
    (() => {
    const componentSelector = 'quantity-breaks';
    const offerSelector = '.quantity-break[data-buy-2-get-1-free="true"]';

    const withDelimiters = (cents, precision, thousands, decimal) => {
      const value = (Number(cents) / 100).toFixed(precision);
      const parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length === 1 ? parts[0] : parts.join(decimal);
    };

    const fallbackFormatMoney = (cents, format) => {
      const moneyFormat = format || '$' + '{' + '{ amount ' + '}' + '}';
      const match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      const placeholder = match ? match[1] : 'amount';
      const formats = {
        amount: [2, ',', '.'],
        amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','],
        amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'],
        amount_with_space_separator: [2, ' ', ','],
        amount_no_decimals_with_space_separator: [0, ' ', ',']
      };
      const selectedFormat = formats[placeholder] || formats.amount;
      const formatted = withDelimiters(cents, selectedFormat[0], selectedFormat[1], selectedFormat[2]);
      return match ? moneyFormat.replace(match[0], formatted) : formatted;
    };

    const formatMoneyValue = (cents, format) => {
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents, format, true);
      }
      return fallbackFormatMoney(cents, format);
    };

    const replaceTokens = (template, values) => {
      let output = template || '';
      Object.entries(values).forEach(([token, value]) => {
        output = output.split(token).join(String(value));
      });
      return output;
    };

    const getVariantData = (component) => {
      if (component.buyTwoGetOneVariantData) {
        return component.buyTwoGetOneVariantData;
      }
      const dataElement = component.querySelector('script[type="application/json"]');
      if (!dataElement) {
        return [];
      }
      try {
        component.buyTwoGetOneVariantData = JSON.parse(dataElement.textContent);
      } catch (error) {
        component.buyTwoGetOneVariantData = [];
      }
      return component.buyTwoGetOneVariantData;
    };

    const updateOffer = (component) => {
      const offer = component.querySelector(offerSelector);
      if (!offer) {
        return;
      }

      const variantsById = new Map(
        getVariantData(component).map((variant) => [String(variant.id), variant])
      );
      const variants = Array.from(offer.querySelectorAll('.quantity-break__selector-item'))
        .map((selector) => variantsById.get(String(selector.dataset.selectedId)))
        .filter(Boolean);

      if (variants.length !== 3) {
        return;
      }

      const regularPrices = variants.map((variant) => Number(variant.price));
      if (regularPrices.some((price) => !Number.isFinite(price))) {
        return;
      }

      const regularTotal = regularPrices.reduce((total, price) => total + price, 0);
      const cheapestPrice = Math.min(...regularPrices);
      const bundlePrice = regularTotal - cheapestPrice;
      const compareTotal = variants.reduce((total, variant) => {
        const comparePrice = Number(variant.compare_at_price);
        return total + (Number.isFinite(comparePrice) && comparePrice > Number(variant.price)
          ? comparePrice
          : Number(variant.price));
      }, 0);
      const quantity = variants.length;
      const roundedSavings = Math.round(cheapestPrice / 100) * 100;
      const percentageSaved = regularTotal > 0
        ? Math.round((cheapestPrice / regularTotal) * 100)
        : 0;
      const moneyFormat = component.dataset.moneyFormat;
      const offerKey = `offer_${String(offer.dataset.input || '').replace('input_', '')}`;

      if (component.offerPrices && component.offerPrices[offerKey]) {
        component.offerPrices[offerKey].price = bundlePrice;
        component.offerPrices[offerKey].compare_price = compareTotal;
      }

      const values = {
        '[quantity]': quantity,
        '[price]': formatMoneyValue(bundlePrice, moneyFormat),
        '[compare_price]': formatMoneyValue(compareTotal, moneyFormat),
        '[amount_saved]': formatMoneyValue(cheapestPrice, moneyFormat),
        '[amount_saved_rounded]': formatMoneyValue(roundedSavings, moneyFormat),
        '[price_each]': formatMoneyValue(bundlePrice / quantity, moneyFormat),
        '[compare_price_each]': formatMoneyValue(compareTotal / quantity, moneyFormat),
        '[percentage_saved]': `${percentageSaved}%`
      };

      offer.querySelectorAll('.variant-price-update').forEach((element) => {
        element.innerHTML = replaceTokens(element.dataset.text, values);
      });

      const compareElement = offer.querySelector('.quantity-break__compare-price');
      if (compareElement) {
        compareElement.classList.toggle('hidden', compareTotal <= bundlePrice);
      }

      const radio = component.querySelector(`input[type="radio"][data-input="${offer.dataset.input}"]`);
      if (radio && radio.checked && component.updatePdpPrices && typeof component.updateDisplayedPdpPrices === 'function') {
        component.updateDisplayedPdpPrices();
      }
    };

    const initializeComponent = (component) => {
      if (component.dataset.buyTwoGetOneInitialized === 'true' || !component.querySelector(offerSelector)) {
        return;
      }
      component.dataset.buyTwoGetOneInitialized = 'true';
      component.addEventListener('change', () => updateOffer(component));
      const observer = new MutationObserver(() => updateOffer(component));
      observer.observe(component, { attributes: true, attributeFilter: ['data-base-price'] });
      component.buyTwoGetOneObserver = observer;
      updateOffer(component);
    };

    const initializeWithin = (root) => {
      const components = [];
      if (root.matches && root.matches(componentSelector)) {
        components.push(root);
      }
      if (root.querySelectorAll) {
        components.push(...root.querySelectorAll(componentSelector));
      }
      components.forEach(initializeComponent);
    };

    const initialize = (root = document) => {
      customElements.whenDefined(componentSelector).then(() => initializeWithin(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
